import React, { useState, useMemo } from "react";
import StatusEmptyCard from "../StatusEmptyCard";
import { jobsFilterEmptyCard } from "../jobsSurface";
import { shopJobDateLabel } from "../shopJobDateLabel";

function shopJobMatchesDateFilter(date, filterTerm) {
  const serialized = JSON.stringify(date);
  const haystack = typeof serialized === "string" ? serialized : "";
  return haystack.toLowerCase().includes(filterTerm || "");
}

function compareShopJobsByDate(a, b, descending) {
  const c = new Date(a.date);
  const d = new Date(b.date);
  const cTime = c.getTime();
  const dTime = d.getTime();
  const cInvalid = Number.isNaN(cTime);
  const dInvalid = Number.isNaN(dTime);
  if (cInvalid && dInvalid) return 0;
  if (cInvalid) return 1;
  if (dInvalid) return -1;
  return descending ? dTime - cTime : cTime - dTime;
}

function shopJobTypeClass(type) {
  if (typeof type !== "string") return "bg-green-300";
  return type.toLowerCase() === "estimate" ? "bg-yellow-200" : "bg-green-300";
}

function shopJobTypeLabel(type) {
  return typeof type === "string" ? type : "";
}

export function shopJobVehicleLabel(vehicle) {
  if (typeof vehicle === "string") return vehicle;
  if (!vehicle || typeof vehicle !== "object") return "";
  return [vehicle.year, vehicle.make, vehicle.model]
    .filter(Boolean)
    .map(String)
    .join(" ");
}

const JobsTableComponent = ({
  setShowModal,
  setActiveJob,
  jobs,
  setShowCancelJobModal,
}) => {
  const [sortingOrder, setSortingOrder] = useState("");

  const [filterTerm, setFilterTerm] = useState("");

  const sortJobs = () => {
    if (sortingOrder === "descending") {
      setSortingOrder("ascending");
    } else {
      setSortingOrder("descending");
    }
  };

  const sortedJobs = useMemo(() => {
    const jobsByDate = [...jobs];
    const descending = sortingOrder === "descending";
    jobsByDate.sort(function (a, b) {
      return compareShopJobsByDate(a, b, descending);
    });
    return jobsByDate;
  }, [jobs, sortingOrder]);

  const filteredShops = sortedJobs.filter((shop) =>
    shopJobMatchesDateFilter(shop.date, filterTerm)
  );

  return (
    <div className="py-2 align-middle inline-block min-w-full">
      <div className="shadow flex">
        <input
          className="w-full rounded p-2 border-none"
          onChange={(value) => setFilterTerm(value.target.value.toLowerCase())}
          type="text"
          placeholder="Filter by date..."
        />
      </div>
      {filteredShops.length === 0 && jobs.length > 0 ? (
        <div className="flex flex-col items-center py-4">
          <StatusEmptyCard
            copy={jobsFilterEmptyCard(jobs.length)}
            onAction={() => setFilterTerm("")}
          />
        </div>
      ) : null}
      {filteredShops.length === 0 ? null : (
      <div className="shadow overflow-hidden border-b border-gray-200 rounded-lg">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Type
              </th>
              <th
                onClick={() => {
                  sortJobs();
                }}
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
              >
                Date {sortingOrder}
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Status
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Assignee
              </th>
              <th
                scope="col"
                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Vehicle
              </th>
              <th
                scope="col"
                className="text-center px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                View
              </th>
              <th
                scope="col"
                className="text-center px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Cancel
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredShops?.map((job) => (
              <tr
                key={job.id}
                className={shopJobTypeClass(job.type)}
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">{shopJobTypeLabel(job.type)}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">{shopJobDateLabel(job)}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900 capitalize">
                    {job.status}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">
                    {job.tech?.name || "None Assigned"}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900 capitalize">
                    {shopJobVehicleLabel(job.vehicle)}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <button
                    className="text-sm text-purple-800"
                    type="button"
                    onClick={() => {
                      setShowModal(true);
                      setActiveJob(job);
                    }}
                  >
                    View
                  </button>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <button
                    className="text-sm text-red-500"
                    type="button"
                    onClick={() => {
                      setActiveJob(job);
                      setShowCancelJobModal(true);
                    }}
                  >
                    Cancel
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      )}
    </div>
  );
};
export default JobsTableComponent;
